import { Auth } from "aws-amplify";
import { saveLastFilter } from "../features/user/saveLastFilter";

export async function signOut(client, user, reload = true) {
  try {
    try {
      await saveLastFilter(client, user);
    } catch (err) {
      console.log("err saving filter: ", err);
    }
    localStorage.removeItem("secondaryAuthAccessToken");
    await Auth.signOut({ global: true });
    if (reload) window.location.reload();
  } catch (error) {
    console.log("error signing out: ", error);
  }
}

